import { ContentWrapper } from "@crunchyroll/cx-web-components";
import styles from "./footer.module.scss";
import FooterNavigationSection from "./FooterNavigationSection";
import FooterSocialsSection from "./FooterSocialsSection";
import FooterMoreStuffSection from "./FooterMoreStuffSection";
import FooterAccountSection from "./FooterAccountSection";
import FooterCopyrightSection from "./FooterCopyrightSection/FooterCopyrightSection";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <ContentWrapper className={styles.sections}>
        <FooterNavigationSection />
        <FooterSocialsSection />
        <FooterMoreStuffSection />
        <FooterAccountSection className={styles.accountSection} />
      </ContentWrapper>
      <FooterCopyrightSection />
    </footer>
  );
};

export default Footer;
